<div
  *ngIf="form"
  class="panel {{ cssClass | editorCssClass }}"
  fxLayout="{{ direction }} wrap"
  fxLayoutAlign="start start"
  [formGroup]="form"
>
  <div
    *ngFor="let item of options"
    class="cell"
    fxFlex="none"
    [class.dark-theme]="(_currentThemeSubject | async) === 'dark'"
    [class.light-theme]="(_currentThemeSubject | async) === 'light'"
  >
    <ng-container *ngIf="!templateName">
      <mat-checkbox [formControlName]="item.value" [ngClass]="{ hidden: inputHidden }">
        {{ item.label }}
      </mat-checkbox>
    </ng-container>
    <ng-container *ngIf="templateName">
      <mat-checkbox [(ngModel)]="item.checked" [ngClass]="{ hidden: inputHidden }" [formControlName]="item.value">
        <ng-container
          [ngTemplateOutlet]="[templates] | findTemplate : templateName"
          [ngTemplateOutletContext]="{ $implicit: { entity: item.data, checked: item?.checked } }"
        ></ng-container>
      </mat-checkbox>
    </ng-container>
  </div>
</div>
